var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card totalCost" }, [
    _c("div", { staticClass: "p-card-header" }, [
      _c("p", { staticClass: "title bold" }, [
        _vm._v(_vm._s(_vm.$t("totalCost.title"))),
      ]),
    ]),
    _vm._v(" "),
    !!_vm.monthlyCost.subscribes.length
      ? _c(
          "div",
          { staticClass: "p-card-content" },
          [
            _c("p", { staticClass: "subtitle" }, [
              _vm._v(_vm._s(_vm.$t("totalCost.monthlyPayments"))),
            ]),
            _vm._v(" "),
            _vm._l(_vm.monthlyCost.subscribes, function (subscribe, index) {
              return _c("div", { key: index }, [
                _c("p", { staticClass: "packageName semiBold" }, [
                  _vm._v(_vm._s(subscribe.plan.title)),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "cost-content" }, [
                  _c("p", [
                    _vm._v(
                      "\n                    " +
                        _vm._s(subscribe.plan.altTitle) +
                        "\n                    "
                    ),
                    subscribe.plan.type == "supsis"
                      ? _c("span", { staticClass: "cost" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(~~(subscribe.plan.price || 0)) +
                              " x (" +
                              _vm._s(subscribe.details.agentCount) +
                              ")\n                        " +
                              _vm._s(_vm.$t("totalCost.currency")) +
                              "\n                    "
                          ),
                        ])
                      : subscribe.plan.type == "whatsapp-business" ||
                        subscribe.plan.type == "whatsapp"
                      ? _c("span", { staticClass: "cost" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(~~(subscribe.plan.price || 0)) +
                              " x (" +
                              _vm._s(subscribe.details.whatsappChannel) +
                              ")\n                        " +
                              _vm._s(_vm.$t("totalCost.currency")) +
                              "\n                    "
                          ),
                        ])
                      : _c("span", { staticClass: "cost" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(~~(subscribe.price || 0)) +
                              " " +
                              _vm._s(_vm.$t("totalCost.currency")) +
                              "\n                    "
                          ),
                        ]),
                  ]),
                ]),
              ])
            }),
            _vm._v(" "),
            _c("div", { staticClass: "cost-total" }, [
              _c("p", { staticClass: "cost bold" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.monthlyCost.total || 0) +
                    "\n                " +
                    _vm._s(_vm.$t("totalCost.currencyMonthly")) +
                    "\n            "
                ),
              ]),
            ]),
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    !!_vm.annualCost.subscribes.length
      ? _c(
          "div",
          { staticClass: "p-card-content" },
          [
            _c("p", { staticClass: "subtitle" }, [
              _vm._v(_vm._s(_vm.$t("totalCost.oneTimePayments"))),
            ]),
            _vm._v(" "),
            _vm._l(_vm.annualCost.subscribes, function (subscribe, index) {
              return _c(
                "div",
                { key: index },
                [
                  _c(
                    "a-row",
                    [
                      _c("a-col", { attrs: { span: 11 } }, [
                        _c("p", { staticClass: "packageName semiBold" }, [
                          _vm._v(_vm._s(subscribe.plan.title)),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("a-row", [
                    _c("div", { staticClass: "cost-content listcontent" }, [
                      _c("p", [
                        _vm._v(
                          "\n                        " +
                            _vm._s(subscribe.plan.altTitle) +
                            "\n                        "
                        ),
                        _c("span", { staticClass: "cost" }, [
                          _vm._v(
                            _vm._s(~~(subscribe.price || 0)) +
                              " " +
                              _vm._s(_vm.$t("totalCost.currency"))
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      subscribe.plan.price * 12 > subscribe.price
                        ? _c("p", [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("totalCost.oneTimeDiscount")) +
                                "\n                        "
                            ),
                            _c("span", { staticClass: "cost discount-cost" }, [
                              _vm._v(
                                "-" +
                                  _vm._s(
                                    ~~(
                                      (subscribe.plan.price || 0) * 12 -
                                      (subscribe.price || 0)
                                    )
                                  ) +
                                  "₺"
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                ],
                1
              )
            }),
            _vm._v(" "),
            _c("div", { staticClass: "cost-total" }, [
              _c("p", { staticClass: "cost bold" }, [
                _vm._v(
                  _vm._s(~~(_vm.annualCost.total || 0)) +
                    " " +
                    _vm._s(_vm.$t("totalCost.currencyYearly"))
                ),
              ]),
            ]),
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "p-card-footer" },
      [
        _c("a-row", [
          _c("div", { staticClass: "total-cost-content listcontent" }, [
            _c("p", [
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.$t("totalCost.totalOneTimeCost")) +
                  "\n                    "
              ),
              _c("span", { staticClass: "cost bold" }, [
                _vm._v(
                  _vm._s(
                    ~~(
                      (_vm.annualCost.total || 0) + (_vm.monthlyCost.total || 0)
                    )
                  ) + " ₺"
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n                    Vergi ( %" +
                  _vm._s(_vm.taxRate) +
                  " )\n                    "
              ),
              _c("span", { staticClass: "cost discount-cost bold" }, [
                _vm._v(
                  _vm._s(
                    ~~(
                      (((_vm.annualCost.total || 0) +
                        (_vm.monthlyCost.total || 0)) *
                        _vm.taxRate) /
                      100
                    )
                  ) +
                    "\n                        " +
                    _vm._s(_vm.$t("totalCost.currency")) +
                    "\n                    "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n                    Vergi Dahil Toplam\n                    "
              ),
              _c("span", { staticClass: "cost discount-cost bold" }, [
                _vm._v(
                  _vm._s(
                    ~~(
                      (_vm.annualCost.total || 0) +
                      (_vm.monthlyCost.total || 0) +
                      (((_vm.annualCost.total || 0) +
                        (_vm.monthlyCost.total || 0)) *
                        _vm.taxRate) /
                        100
                    )
                  ) +
                    "\n                        " +
                    _vm._s(_vm.$t("totalCost.currency")) +
                    "\n                    "
                ),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("a-row", [
          _c("p", { staticClass: "code-label" }, [
            _vm._v(_vm._s(_vm.$t("totalCost.referenceCode"))),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "input-group discount-code mb-3" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.referenceCode,
                  expression: "referenceCode",
                },
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                placeholder: _vm.$t("totalCost.referencePlaceholder"),
              },
              domProps: { value: _vm.referenceCode },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.referenceCode = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "input-group-append" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-outline-secondary",
                  attrs: { type: "button" },
                },
                [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t("totalCost.codeButton")) +
                      "\n                    "
                  ),
                ]
              ),
            ]),
          ]),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "footer" },
      [
        _vm.monthlyCost.total
          ? _c(
              "a-row",
              [
                _c(
                  "a-col",
                  { staticClass: "cost-label", attrs: { span: 17 } },
                  [_vm._v(_vm._s(_vm.$t("totalCost.monthlyCost")))]
                ),
                _vm._v(" "),
                _c("a-col", { staticClass: "cost", attrs: { span: 7 } }, [
                  _vm._v(_vm._s(~~_vm.monthlyCost.total) + "₺"),
                ]),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.annualCost.total > 0
          ? _c(
              "a-row",
              [
                _c(
                  "a-col",
                  { staticClass: "cost-label", attrs: { span: 17 } },
                  [_vm._v(_vm._s(_vm.$t("totalCost.oneTimeFullCost")))]
                ),
                _vm._v(" "),
                _c("a-col", { staticClass: "cost", attrs: { span: 7 } }, [
                  _vm._v(_vm._s(~~_vm.annualCost.total) + "₺"),
                ]),
              ],
              1
            )
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "card-footer btn btn-outline-secondary last-button",
        attrs: { disabled: _vm.disableComplateButton },
        on: { click: _vm.complateWizard },
      },
      [_vm._v("\n        Devam Et\n    ")]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }